import { Avatar, Space, Typography, Dropdown, message } from "antd";
import React, { useState } from "react";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";

//
//component
//redux
//selector
//actions

import { emailSelector } from "store/user/auth/user_auth.selector";
//utils
//hook
//str
import "./header_user.css";
import { silentLogout } from "store/bailiff/login/login.action";
import { useFlow, FLOWS } from "hook/draft/dialog/flow/useFlow";
import { setDraftDialogPlay } from "store/bailiff/task/dialog/draft_dialog.action";

const HeaderUser = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useFlow();
  const hasTask = flow === FLOWS.HAS_TASK;
  // -------------------------- STATE ---------------------------
  const [open, setOpen] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const email = useSelector(emailSelector);
  const name = email?.split("@")?.[0] || "New Account";

  // -------------------------- FUNCTION ------------------------
  const handleLogout = () => {
    if (hasTask) {
      message.info("Vui lòng hoàn thành hoặc rời nhiệm vụ trước khi đăng xuất");
      return;
    }
    dispatch(setDraftDialogPlay(false));
    dispatch(silentLogout());
  };

  const handleChange = (value) => {
    setOpen(value);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const items = [
    {
      key: "1",
      label: (
        <Space onClick={handleLogout}>
          <LogoutOutlined />
          <Typography.Text>Đăng Xuất</Typography.Text>
        </Space>
      ),
    },
  ];

  // -------------------------- MAIN ----------------------------
  return (
    <Dropdown
      menu={{ items }}
      placement="bottom"
      trigger={["hover"]}
      open={open}
      onOpenChange={handleChange}
      className="logout-dropdown"
    >
      <div
        style={{
          width: 150,
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
        }}
      >
        <div>
          <Avatar size="small" icon={<UserOutlined />} />
        </div>
        <div className="flex items-center">
          <Typography.Text
            className="ml-2"
            ellipsis={{ rows: 1 }}
            type="secondary"
          >
            {name}
          </Typography.Text>
        </div>
      </div>
    </Dropdown>
  );
};
export default HeaderUser;
